import React, { memo } from 'react';
import { Question } from 'types/sku.types';

/**
 * Mostly used for a Question component to display a subhint, but can be used
 * for any subhint, just pass in the subhint as a prop.
 */
interface PreQuestionSubhintProps {
  question?: Question;
  hint?: string;
}

const PreQuestionSubhint: React.FC<PreQuestionSubhintProps> = ({ question, hint }) => {
  const subhint = hint || question?.subhint;

  return subhint ? <p className="caption n700">{subhint}</p> : null;
};

export default memo(PreQuestionSubhint);
